import { createResourceApi } from 'resources/ResourceApi';
import { RoomTypeApiItem } from 'typings/api';

export default createResourceApi<RoomTypeApiItem>('room_types');
